var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRowSpanLineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    width: "400px",
    height: "400px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10,90L90,90L90,10L10,10L10,90ZM65,35L65,15L85,15L85,35L65,35ZM40,35L40,15L60,15L60,35L40,35ZM65,60L65,40L85,40L85,60L65,60ZM40,60L40,40L60,40L60,60L40,60ZM15,60L15,15L35,15L35,60L15,60ZM65,85L65,65L85,65L85,85L65,85ZM40,85L40,65L60,65L60,85L40,85ZM15,85L15,65L35,65L35,85L15,85Z",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRowSpanLineIcon);
export default __webpack_public_path__ + "static/media/RowSpanLineIcon.8c95f9124ce7e12edfd758c708375901.svg";
export { ForwardRef as ReactComponent };